import { useCallback, useEffect, useMemo, useState } from "react";

import { GetOrderByStatusIdAndDate } from "../services/orderService";
//import CommonDateRangePicker from "../utils/CommonDateRangePicker";

import CAgGrid from "./CAgGrid";
import CustomDateRange from "../utils/CustomDateRange";
import CommonGridHeader from "./CommonGridHeader";

const today = new Date().toISOString().split("T")[0];

const CommonOrders = ({ statusId,columnDefs,h4,ndrStatus = false, }) => {
  //implement header fields
const defaultFields = useMemo(
  () => columnDefs.map(col => col.field),
  [columnDefs]
);
const [selectedFields, setSelectedFields] = useState(defaultFields);
useEffect(() => {
  setSelectedFields(defaultFields);
}, [defaultFields]);

  const handleFieldChange = (field) => {
        setSelectedFields(prev =>
            prev.includes(field)
                ? prev.filter(x => x !== field)
                : [...prev, field]
        );
    };
    const handleReset = () => {
        setSelectedFields(defaultFields);
    };
    const visibleColumnDefs = useMemo(() => {
  return columnDefs.filter(col => selectedFields.includes(col.field));
}, [columnDefs, selectedFields]);
  // end here
  const userId = useMemo(
    () => Number(localStorage.getItem("userid")),
    []
  );

  const [dateRange, setDateRange] = useState({
    startDate: today,
    endDate: today,
  });

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      sortable: true,
      filter: true,
      resizable: true,
    }),
    []
  );

  const fetchOrders = useCallback(async (startDate, endDate) => {
    try {
      setLoading(true);

      const response = await GetOrderByStatusIdAndDate(
        userId,
        Number(statusId),
        startDate,
        endDate,
        ndrStatus
      );

      const data =
        response?.data?.map((item) => ({
          id: item.id,
          dateCreated: item.dateCreated
        ? new Date(item.dateCreated).toLocaleString()
        : "",
          orderId: item.id,
          orderType:item.orderType,
          customerName: `${item.firstName} ${item.lastName}`,
          wayBill:item.wayBill,
          courierStatus:item.courierStatus,
          courier:item.courier,
          courierMasterId:item.courierMasterId,
          servicability:item.servicability,
          mobile: item.mobile,
          email:item.email,
          city: item.city,
          state: item.state,
          pincode: item.postalCode,
          totalAmount: item.gTotal,
          paymentType: item.payment?.name,
          diseaseName: item.issueDisease?.name,
          ndrDate:item.ndrDate,
          teleCaller: item.teleCaller ?? "",
      teamLeader: item.teamLeader ?? "",
          product: item.getOrderItemDtos
            ?.map((x) => x.productName)
            .join(", "),
          quantity: item.getOrderItemDtos
            ?.reduce((sum, x) => sum + x.quantity, 0),
          totalItem: item.getOrderItemDtos?.length,
        })) || [];
      setRowData(data);
    } catch (error) {
      console.error("Failed to load orders:", error);
      setRowData([]);
    } finally {
      setLoading(false);
    }
  }, [userId, statusId,ndrStatus]);

  // Initial load only

 useEffect(() => {
  fetchOrders(today, today);
}, [fetchOrders]);

  const handleSearch = () => {
    fetchOrders(dateRange.startDate, dateRange.endDate);
  };
const handleRowClick = (event) => {
    console.log("Clicked Row:", event.data);
  };
  const handleDateChange = ({ startDate, endDate }) => {
    setDateRange({
      startDate,
      endDate,
    });
  };

  return (
  <>
    <h4 className="mb-3">{h4}</h4>
 {/* <CommonGridHeader
                title="List Orders"
                fields={columnDefs}  //{ORDER_FIELDS}
                selectedFields={selectedFields}
                onFieldChange={handleFieldChange}
                onReset={handleReset}
            /> */}

            <CommonGridHeader
    fields={columnDefs.map(col => ({
        key: col.field,
        label: col.headerName
    }))}
    selectedFields={selectedFields}
    onFieldChange={handleFieldChange}
    onReset={handleReset}
/>

    {Number(statusId) !== 8 && (
      <div className="d-flex align-items-center gap-2 mb-3">
        {/* <CommonDateRangePicker
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          onApply={handleDateChange}
        /> */}
        <CustomDateRange
                        startDate={dateRange.startDate}
                        endDate={dateRange.endDate}
                        onChange={handleDateChange}
                      />

        <button
          className="btn btn-primary"
          onClick={handleSearch}
          disabled={loading}
        >
          {loading ? "Loading..." : "Search"}
        </button>
      </div>
    )}
    


    <div className="mb-3">
      <strong>Total Orders:</strong> {rowData.length}
    </div>

    <CAgGrid
      rowData={rowData}
      columnDefs={visibleColumnDefs}
      defaultColDef={defaultColDef}
      pagination={true}
      paginationPageSize={20}
      rowSelection="multiple"
      height="400px"
      onRowClicked={handleRowClick}
    />
  </>
);
};

export default CommonOrders;